<ag-grid-angular
  data-testid="failed-refunds-table"
  class="ag-theme-quartz margin-top-med margin-bottom-med"
  [tooltipShowDelay]=0
  domLayout='autoHeight'
  [rowHeight]="50"
  rowClass="table-row"
  (firstDataRendered)="onFirstDataRendered($event)"
  (gridSizeChanged)="gridSizeChanged($event)"
  overlayNoRowsTemplate="<span>No failed refunds found</span>"
  [rowData]="failedRefunds"
  [columnDefs]="failedRefundColDefs">
</ag-grid-angular>
